module.exports = __webpack_public_path__ + "static/media/map-marker.3c0dd818.svg";